export enum JobStatus {
  SUBMITTED,
  PROCESSING,
  PRINTING,
  PRINTED,
  READY,
  EXPIRED,
}
